__turbopack_context__.v({
  "default": "anchor-module-scss-module__KXzGnq__default",
});
